import { render, staticRenderFns } from "./wr4.vue?vue&type=template&id=1121fd34&scoped=true&"
import script from "./wr4.vue?vue&type=script&lang=js&"
export * from "./wr4.vue?vue&type=script&lang=js&"
import style0 from "./wr4.vue?vue&type=style&index=0&id=1121fd34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1121fd34",
  null
  
)

export default component.exports